import type { PropsWithChildren } from 'react'

import styled from 'styled-components'

import { Background } from 'components/Background'
import { Logo } from 'components/Logo'
import { Screen } from 'components/Screen'
import {
  AppContainer,
  AppFrame,
  AppScreen,
  AppViewport,
} from 'components/layouts/styles'
import { Headline, Text } from 'components/typography'
import { useLocaleTranslation } from 'hooks/useLocaleTranslation'
import { space } from 'theme/utils'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  max-width: 400px;
  gap: ${space(8)};
  height: 100%;
`

/**
 * Locked layout when the user isn't authorized
 */
export const Locked = ({ children }: PropsWithChildren): JSX.Element => {
  const { _ } = useLocaleTranslation('Locked')

  // Get code from query parameters
  const urlParams = new URLSearchParams(window.location.search)
  const code = urlParams.get('code')

  // Show different message based on whether code was provided
  const messageKey = code ? 'query-code-required' : 'query-not-found'

  return (
    <AppFrame>
      <Background animated />
      <AppViewport>
        <AppContainer>
          <Logo />
          <AppScreen>
            <Screen>
              <Container>
                <Headline $size="large">{_('title')}</Headline>
                <Text>{_(messageKey)}</Text>
                {children}
              </Container>
            </Screen>
          </AppScreen>
        </AppContainer>
      </AppViewport>
    </AppFrame>
  )
}
